import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CatalogDataService } from '../../../core/services/catalog-data.service';
import { Router } from '@angular/router';
import { PointFilter } from '../../../rewards/enums/point-filter.enum';

@Component({
  selector: 'app-modal-remaining-points',
  imports: [],
  templateUrl: './modal-remaining-points.component.html',
  styles: ``
})
export class ModalRemainingPointsComponent {

  private activeModal = inject(NgbActiveModal);
  private router = inject(Router);
  private catalogDataService = inject(CatalogDataService);

  goToCatalog(min: number, max: number) {
    this.catalogDataService.setFilter(PointFilter.ByPointsRange);
    this.catalogDataService.setFilterByPoints(min, max);
    this.router.navigate([`/rewards/catalog`]);
    this.activeModal.dismiss();
  }

  close(): void {
    this.activeModal.dismiss();
  }
}
